import React from 'react';
import PropTypes from 'prop-types';
import cns from 'classnames';
import Modal from 'react-modal';
import { getModalStyling } from '../../utils/ModalUtils';
import VerbButton, { VERB_BUTTON_TYPE } from '../VerbButton';
import VerbText from '../VerbText';

const ConfirmationModal = ({
    messageTextProp,
    cancelButtonProp = {},
    actionButtonProp = {},
    cancelFunc,
    actionFunc,
    isOpen,
    title
}) => {
    if (!messageTextProp) {
        return null;
    }
    return (
        <Modal
            className={cns('verb-modal admin-modal confirmation-modal')}
            style={getModalStyling({ content: { width: '700px' } })}
            isOpen={isOpen}
            contentLabel={'Modal'}
        >
            <div className={'baseModal main-panel'}>
                <div className={'row confirmation-msg-title'}>{title}</div>
                <div className={'confirmation-msg-container'}>
                    <VerbText messageId={messageTextProp.messageId} defaultMessage={messageTextProp.defaultMessage} />
                </div>
                <div className={'bottom-panel'}>
                    <div className={'row button-container'}>
                        <VerbButton
                            className={'col-xs'}
                            textId={cancelButtonProp.textId}
                            buttonType={VERB_BUTTON_TYPE.SECONDARY_DEFAULT}
                            defaultMessage={cancelButtonProp.defaultMessage}
                            onClick={cancelFunc}
                        />
                        <VerbButton
                            className={'col-xs ms-auto submit-button'}
                            type={'submit'}
                            textId={actionButtonProp.textId}
                            defaultMessage={actionButtonProp.defaultMessage}
                            onClick={actionFunc}
                        />
                    </div>
                </div>
            </div>
        </Modal>
    );
};

ConfirmationModal.propTypes = {
    messageTextProp: PropTypes.object,
    cancelButtonProp: PropTypes.object,
    actionButtonProp: PropTypes.object,
    cancelFunc: PropTypes.func,
    actionFunc: PropTypes.func,
    isOpen: PropTypes.bool,
    title: PropTypes.string
};

export default ConfirmationModal;
